import React from 'react';
import MasterSidebar from './MasterSidebar';
import { Link } from 'react-router-dom';

/**
 * MasterLayout - Main layout for the Super Admin / SaaS Owner Dashboard
 */
const MasterLayout = ({ children }) => {
    const userEmail = localStorage.getItem('userEmail') || 'admin@visiopadel.com';
    const userName = localStorage.getItem('userName') || 'Admin Maestro';

    const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);

    return (
        <div className="flex min-h-screen bg-slate-50">
            {/* Sidebar Adminsitrativo */}
            <MasterSidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />

            {/* Contenido principal */}
            <div className="flex-1 flex flex-col min-h-screen">
                {/* Topbar del Master Dashboard */}
                <header className="bg-white border-b border-slate-200 h-16 md:h-20 flex items-center justify-between px-4 md:px-8 sticky top-0 z-40">
                    <div className="flex items-center gap-2 md:gap-4">
                        {/* Mobile Toggle Button */}
                        <button
                            onClick={() => setIsSidebarOpen(true)}
                            className="md:hidden p-2 text-slate-500 hover:bg-slate-100 rounded-lg transition-colors"
                        >
                            <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                            </svg>
                        </button>

                        <div className="flex items-center gap-4 text-sm text-slate-500 font-medium hidden sm:flex">
                            <Link to="/" className="hover:text-primary-600 transition-colors">VisioPadel Home</Link>
                            <span>/</span>
                            <span className="text-slate-900 font-bold uppercase tracking-widest text-[10px]">Portal de Control Maestro</span>
                        </div>
                    </div>

                    <div className="flex items-center gap-6">
                        {/* Perfil Admin */}
                        <div className="flex items-center gap-3">
                            <div className="text-right hidden sm:block">
                                <p className="text-xs font-black text-slate-900 leading-none mb-1 uppercase tracking-tight">{userName}</p>
                                <p className="text-[10px] text-slate-500 leading-none italic">{userEmail}</p>
                            </div>
                            <div className="h-10 w-10 rounded-xl bg-slate-900 border border-slate-800 flex items-center justify-center text-primary-400 font-black shadow-lg">
                                {userName.charAt(0)}
                            </div>
                        </div>
                    </div>
                </header>

                {/* Área de Contenido */}
                <main className="p-4 sm:p-6 lg:p-8 flex-grow overflow-x-hidden">
                    {children}
                </main>

                <footer className="py-6 px-8 border-t border-slate-100 text-center text-[10px] text-slate-400 font-bold uppercase tracking-widest">
                    &copy; 2025 VisioPadel SaaS - Sistema de Control Maestro v1.0
                </footer>
            </div>
        </div>
    );
};

export default MasterLayout;
